<terra-dialog-header>
  <h1 *ngIf="isDistribution">Distribution {{data.transactionName}}</h1>
  <h1 *ngIf="!isDistribution">{{data.transactionName}}</h1>
</terra-dialog-header>

<mat-dialog-content>
  <ng-container *ngIf="isDistribution else contribution">
    <p>Date: {{data.date | date}}</p>
    <p>To: {{data.investingEntityName}}</p>
    <p *ngIf="!isMultiTypeDistribution">Type: {{data.distributionType | enumString: distributionType}}</p>
    <p>Status: {{data.status | enumString: transactionStatus}}</p>
    <hr>

    <div *ngFor="let transferDetails of data.distributionTransferDetails">
      @if((((transferDetails.amountGross || 0) - (transferDetails.gpPromote || 0)) > 0) || transferDetails.amountNet > 0){
      <!-- Multi Type type -->
      <p *ngIf="isMultiTypeDistribution" class="underline">
        Type: {{ transferDetails.reasonForTransaction | enumString: distributionType }}
      </p>
      <!-- Gross Amount -->
      <!-- TEMP HOTFIX hide GP Promote but calculate gp promote in gross -->
      <p>
        Gross {{ isMultiTypeDistribution ? 'Amount' : 'Distribution' }}
        : {{ data.currency.symbol }}{{ (transferDetails.amountGross - (transferDetails.gpPromote || 0)) | terraNumber }} {{ data.currency.iso | hideUsdIso }}
      </p>
      <!-- Taxes -->
      <p *ngIf="transferDetails.taxes > 0">
        Withheld Taxes: {{ data.currency.symbol }}{{ transferDetails.taxes || 0 | terraNumber }} {{ data.currency.iso | hideUsdIso }}
      </p>
      <!-- Adjustments -->
      <p *ngIf="transferDetails.adjustments">
        Adjustments: {{ data.currency.symbol }}{{ transferDetails.adjustments | terraNumber }} {{ data.currency.iso | hideUsdIso }}
      </p>
      <!-- Adjustments comments -->
      <div *ngIf="transferDetails.adjustmentsComments" class="multi-line">
        <p class="multi-line-label">Adjustments Comments: </p>
        <p [innerHTML]="parseLineBreaks(transferDetails.adjustmentsComments)" class="multi-line-content"></p>
      </div>
      <!-- Net Amount -->
      <p [ngClass]="{'bold': !isMultiTypeDistribution}">
        Net {{ isMultiTypeDistribution ? 'Amount' : 'Distribution' }}: {{ data.currency.symbol }}{{ transferDetails.amountNet | terraNumber }} {{ data.currency.iso | hideUsdIso }}
      </p>
      <hr>
      }
    </div>

    <!-- Total amounts for multi type distribution -->
    <div *ngIf="isMultiTypeDistribution">
      <!--  Title -->
      <p class="underline">
        <strong>Total Distribution:</strong>
      </p>
      <!--  Gross Amount -->
      <p>
        Gross Distribution: {{ data.currency.symbol }}{{ ((data.amountGross || 0) - (data.gpPromote || 0)) | terraNumber }} {{ data.currency.iso | hideUsdIso }}
      </p>
      <!-- Taxes -->
      <p *ngIf="data.taxes > 0">
        Withheld Taxes: {{ data.currency.symbol }}{{ data.taxes | terraNumber }} {{data.currency.iso | hideUsdIso }}
      </p>
      <!-- Adjustments -->
      <p *ngIf="data.adjustments > 0">
        Adjustments: {{ data.currency.symbol }}{{ data.adjustments | terraNumber }} {{data.currency.iso | hideUsdIso }}
      </p>
      <!-- Net Amount -->
      <p>
        <strong>Net Distribution: {{ data.currency.symbol }}{{ data.amountNet | terraNumber }} {{data.currency.iso | hideUsdIso }}</strong>
      </p>
      <hr *ngIf="data.orderDetails">
    </div>

    <div *ngIf="data.orderDetails">
      <p *ngIf="feeAmount">Transaction Fee: {{ data.currency.symbol }}{{ feeAmount | terraNumber }} {{ data.currency.iso | hideUsdIso }}</p>
      <p *ngIf="data.orderDetails.fromCurrency.id !== data.orderDetails.toCurrency.id">
        Conversion Rate: ({{data.orderDetails.fromCurrency.iso}} - {{data.orderDetails.toCurrency.iso}}) {{inverseExchangeRate.toFixed(2)}} (Inverse: {{exchangeRate.toFixed(2)}})
      </p>
      <p *ngIf="data.orderDetails.fromCurrency.id === data.orderDetails.toCurrency.id && data.orderDetails.markupPercent">
        Markup: {{data.currency.symbol}}{{calculatedMarkup.toFixed(2)}} {{data.currency.iso | hideUsdIso}} ({{data.orderDetails.markupPercent}}%)
      </p>
      <p>Amount You Receive: {{ data.orderDetails.toCurrency.symbol }}{{ receiveAmount | terraNumber }} {{ data.orderDetails.toCurrency.iso | hideUsdIso }}</p>
      <p>(*) Amounts are subject to change.</p>
    </div>
  </ng-container>

  <ng-template #contribution>
    <p>Date: {{data.date | date}}</p>
    <p>From: {{data.investingEntityName}}</p>
    <p>Status: {{data.status | enumString: transactionStatus}}</p>
    <hr>

    <div class="multi-line">
      <p class="multi-line-label">Remarks: </p>
      <p class="multi-line-content" [innerHTML]="parseLineBreaks(data.remarks)"></p>
    </div>
    <p>
      <strong>Amount: {{data.currency.symbol}}{{data.amountGross | terraNumber}} {{ data.currency.iso | hideUsdIso }}</strong>
    </p>

  </ng-template>
</mat-dialog-content>
